import Vue from 'vue'
import store from './store'

Vue.config.productionTip = false

Vue.use(store)

import OrderForm from './pages/OrderForm.vue'
import FloatingCart from './components/FloatingCart.vue'


new Vue({
  store,
  components: { FloatingCart, OrderForm },
  computed: {
    year () {
      let today = new Date()
      return today.getFullYear()
    }
  },
  methods: {
    addItem (item) {
      this.$store.dispatch('addItem', item)
    },
  },
  created() {
  },

}).$mount('#menu-app')
